import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import {
  getExcel,
  getPrimaryProjects,
  searchPrimaryProjects,
  uploadExcel,
} from "../../api/Primary";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { IoMdSend } from "react-icons/io";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { proxy } from "../../config";

const PrimaryProjectsComponent = () => {
  const cookie = new Cookies();
  const navigate = useNavigate();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [loading, setLoading] = useState(true);
  const [isClick, setIsClick] = useState(false);
  const [projects, setProjects] = useState(null);
  const [pageCount, setPageCount] = useState([]);
  const [projectType, setProjectType] = useState("Residential");
  const [currentPage, setCurrentPage] = useState(cookie.get("page") || 1);
  const [searchValue, setSearchValue] = useState("");

  const unitsGet = () => {
    if (searchValue && searchValue !== "") {
      searchPrimaryProjects(currentPage, projectType, searchValue).then(
        (result) => {
          setProjects(result.data.projects);
          setLoading(false);
          setPageCount(result.data.pageCount);
        },
      );
    } else {
      getPrimaryProjects(currentPage, projectType).then((result) => {
        setProjects(result.data.projects);
        setLoading(false);
        setPageCount(result.data.pageCount);
      });
    }
  };

  useEffect(() => {
    unitsGet();
  }, [currentPage, projectType]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePageClick(1)
    unitsGet();
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const uploadFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsClick(true);
      setProjects(null);
      const formBack = new FormData();
      formBack.append("excel", e.target.files[0]);
      uploadExcel(formBack).then((result) => {
        unitsGet();
        setIsClick(false);
        toast.success("Successfully Uploaded", {
          position: "top-right",
        });
      });
    }
  };

  return (
    <>
      {projects === null || loading ? (
        <LoadingPage />
      ) : (
        <div>
          {isSuper && (
            <>
              {isClick ? (
                <div
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <div className="spinner"></div>
                </div>
              ) : (
                <button
                  className="paginationButton"
                  onClick={() => {
                    setIsClick(true);
                    getExcel().then((value) => {
                      setIsClick(false);
                    });
                  }}
                >
                  Download
                </button>
              )}
            </>
          )}

          {!isClick && (
            <>
              {isSuper && (
                <input
                  type="file"
                  id="file"
                  name="file"
                  onChange={(e) => uploadFile(e)}
                  accept=".xlsx"
                  className="paginationButton"
                />
              )}
            </>
          )}
          <div
            style={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <button
              onClick={() => {
                setCurrentPage(1);
                setProjectType("Residential");
              }}
              className={
                projectType !== "Residential"
                  ? "paginationButtonActive"
                  : "paginationButton"
              }
            >
              Residential
            </button>
            <button
              onClick={() => {
                setCurrentPage(1);
                setProjectType("Commercial");
              }}
              className={
                projectType !== "Commercial"
                  ? "paginationButtonActive"
                  : "paginationButton"
              }
            >
              Commercial
            </button>
          </div>

          <div className="search-container">
            <form onSubmit={handleSubmit}>
              <div className="search-input-wrapper">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Name or Dev Name Or id"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="search-input"
                />
                <button
                  type="submit"
                  className="password-toggle"
                  aria-label="Show password"
                >
                  <IoMdSend />
                </button>
              </div>
            </form>
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {renderPageNumbers()}
            <button
              onClick={handleNext}
              disabled={currentPage === pageCount}
              className="paginationButton"
            >
              Next
            </button>
          </div>

          <div className="card-cards">
            {projects?.length === 0 ? (
              <div>Not found</div>
            ) : (
              <>
                {projects?.map((project) => (
                  <div
                    key={project._id}
                    className={`card-card ${project.ban ? "banned" : ""}`}
                  >
                    <div className="card-info">
                      <div>
                        <p className="line">
                          <span className="label">Project name:</span>{" "}
                          {project.name}
                        </p>
                        <p className="line">
                          <span className="label">Dev Name:</span>{" "}
                          {project.developerName}
                        </p>
                        <p className="line">
                          <span className="label">Upload:</span>{" "}
                          {project.uploadFrom === "Nawy"? "N" : project.uploadFrom === "Master V"? "V" : "P"}
                        </p>
                      </div>
                    </div>
                    <div className="card-actions">
                      <button
                        onClick={() => {
                          navigate(`/primary/${project._id}`);
                        }}
                        className="action-btn accept-btn"
                      >
                        View
                      </button>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default PrimaryProjectsComponent;
